import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';

import { ISubNavPage } from '@shared/core/components/subNav';
import { Observable } from 'rxjs';
import { startWith, delay } from 'rxjs/operators';

@Component({
    selector: 'shared-auth-link',
    templateUrl: './auth-link.shared.component.html',
    styleUrls: ['./auth-link.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLinkComponent implements OnInit {
    private _isDropdownOpen: boolean = false;
    @Input() public dropdownTheme: OLO.Components.DropDown.IDropDownTheme = 'light-2';
    @Input() public inverted: boolean = true;
    @Input() public icon: string = 'user';
    @Input() public dropdownWidth: OLO.Components.DROPDOWN_WIDTH;
    @Input() public dropdownSize: OLO.Components.DropDown.IDropDownSize;
    @Input() public size: OLO.Components.BUTTON_SIZE;

    @Output() public onDropdownToggle: EventEmitter<boolean> = new EventEmitter();
    @Output() public onDropdownSelected: EventEmitter<OLO.Components.DropDown.IDropDownOption> = new EventEmitter();

    public label$: Observable<string>;
    public isAuthorized$: Observable<boolean>;
    public options$: Observable<ISubNavPage[]>;
    public showAccountBalance$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
        public routeService: Services.RouteService,
    ) { }

    ngOnInit(): void {
        if (!this.dropdownWidth) {
            this.dropdownWidth = 'md';
            this.dropdownSize = 'lg';
        }

        this.label$ = this.controllers.members.getSignInLabel$();
        this.isAuthorized$ = this.controllers.members.isAuthorized$();
        this.showAccountBalance$ = this.controllers.members.showAccountBalance$();
        this.options$ = this.controllers.routes.accountPagesForUCP$()
            .pipe(
                startWith(null),
                delay(0),
            );

    }

    public handleClick($event: Event): void {
        this.controllers.routes.authAction();
    }

    public dropdownToggle($event: boolean): void {
        this._isDropdownOpen = $event;
        this.onDropdownToggle.emit($event);
        this.changeDetectorRef.detectChanges();
    }

    public async dropdownSelected($event: OLO.Components.DropDown.IDropDownOption): Promise<boolean> {
        this.onDropdownSelected.emit($event);
        this.changeDetectorRef.detectChanges();
        if ($event.Id === -1) {
            this.controllers.members.signOut('/', true);
            return true;
        }

        if ($event.Url) {
            return this.routeService.navigate([$event.Url]);
        }

        console.warn(`Error - "Url" property not provided for option: `, $event);
    }

    public get isExpanded(): boolean {
        return this._isDropdownOpen;
    }
}
